import { ADMIN_API } from "./adminApi";
import { ApiOk, Paginated } from "./adminCommon.types";

export type AdminClienteListItem = {
  id: number;
  razaoSocial: string;
  emailPrincipal: string;
  telefoneCelular: string;
  plano: string;
  status: "ativo" | "inativo" | "suspenso";
  /**
   * Bloqueio de operacao, separado de `status`. Com ele ligado o cliente
   * entra na plataforma e ve o que ja despachou, mas nao cria cotacao nem
   * emite. `status` continua sendo o que barra o login.
   */
  enviosBloqueados?: boolean;
  enviosBloqueadosMotivo?: string | null;
  enviosBloqueadosEm?: string | null;
  tipoConta: string;
  cnpj: string;
  tipoDocumento: string;
  createdAt: string;
  lastLoginAt: string | null;
  shopifyConectado: boolean;
  nuvemshopConectado: boolean;
  ultimaSincronizacao: string | null;
};

export type AdminClienteFilters = {
  page?: number;
  pageSize?: number;
  status?: string;
  plano?: string;
  search?: string;
  plataforma?: string;
};

export const listAdminClientes = async (filters: AdminClienteFilters = {}) => {
  const { data } = await ADMIN_API.get<Paginated<AdminClienteListItem>>("/api/admin/clientes", {
    params: filters,
  });
  return data;
};

export type AdminClienteDetail = {
  cliente: any;
  integracoes: {
    shopify: { conectado: boolean; loja?: string; tokenValido?: boolean; tokenExpiraEm?: string | null };
    nuvemshop: { conectado: boolean; loja?: string; tokenValido?: boolean };
  };
  estatisticas: {
    pedidosImportados: number;
    enviosRealizados: number;
    etiquetasEmitidas: number;
    ultimoPedido: any;
    ultimoAcesso: string | null;
  };
  historico: Array<Record<string, any>>;
};

export const getAdminClienteDetail = async (id: string | number) => {
  const { data } = await ADMIN_API.get<ApiOk<AdminClienteDetail>>(`/api/admin/clientes/${id}`);
  return data.data;
};

export const updateAdminClienteStatus = async (id: string | number, status: string) => {
  const { data } = await ADMIN_API.patch<ApiOk<{ id: number; status: string }>>(
    `/api/admin/clientes/${id}/status`,
    { status }
  );
  return data.data;
};

/**
 * Liga ou desliga o bloqueio de envios do cliente.
 * PATCH /api/admin/clientes/:id/envios
 */
export const updateAdminClienteEnvios = async (
  id: string | number,
  bloqueado: boolean,
  motivo?: string,
) => {
  const { data } = await ADMIN_API.patch<
    ApiOk<{
      id: number;
      enviosBloqueados: boolean;
      enviosBloqueadosMotivo: string | null;
    }>
  >(`/api/admin/clientes/${id}/envios`, { bloqueado, motivo });
  return data;
};
